module.exports = __webpack_public_path__ + "1defaf8052577692e442b58e12bd5c52.png";